<template>
  <div class="content-view">
    <div id="imgDiv" v-show="false"></div>
    <div data-v-6f13ff2a="" class="page">
      <div data-v-6f13ff2a="" class="page-warp">
        <div data-v-1c192527="" data-v-6f13ff2a="" class="page-col">
          <div
            data-v-408bd9a2=""
            data-v-1c192527=""
            data-v-6f13ff2a=""
          >
            <div data-v-408bd9a2="" class="catalog-card-content">
               <div data-v-2113713f="" data-v-6f13ff2a="" class="page-col2">
      <div
        data-v-389d87ef=""
        data-v-2620c8cd=""
        data-v-2113713f=""
        class="card-wrap page"
        data-v-6f13ff2a=""
      >
        <div data-v-389d87ef="" class="card-wrap-header">
          <div data-v-389d87ef="" class="title">
            <div data-v-389d87ef="" class="flex">
              <div data-v-389d87ef="" class="unicon"></div>
               <span
                data-v-389d87ef=""
                class="card-wrap-title"
                style="cursor: pointer"
              >
                文献元数据 </span
              ><!---->

            </div>
          </div>
        </div>
        <div data-v-389d87ef="" class="card-wrap-content">
          <div data-v-2620c8cd="" data-v-389d87ef="" class="struct">
            <div
              data-v-a36ddf66=""
              data-v-2620c8cd=""
              class="description"
              data-v-389d87ef=""
            >
              <div data-v-a36ddf66="" class="description-body">
                <div data-v-6edc5341="" data-v-3fdac0fc="" style="display: -webkit-box">
                <div data-v-6edc5341="" class="bookinfo-left" ><img data-v-6edc5341="" :src="pagePic" class="bookinfo-img"><!----></div>
                <div data-v-6edc5341="" class="bookinfo-info"><div data-v-6edc5341="" class="title"> {{bookDetail.title}}</div><div data-v-6edc5341="" class="infos">
                  <div data-v-6edc5341="" class="row">
                    <span data-v-6edc5341="" class="lable">摘要</span><span data-v-6edc5341="">：</span></div>
                    <div data-v-6edc5341="" style="width:800px;margin:30px">
                    <span data-v-6edc5341="">{{bookDetail.description}}</span><span data-v-6edc5341=""></span></div>
                    </div>

                     <button
                        data-v-6edc5341=""
                        type="button"
                        class="el-button el-button--danger"
                        @click="goToPage()"
                      >
                        <!----><i class="lib-icon-book"></i
                        ><span> &nbsp;&nbsp;立即阅读 </span>
                      </button>
                    </div>
                </div>
                </div>
              <div data-v-a36ddf66="" class="description-body">
                  <div data-v-408bd9a2="" class="el-row">
                <div data-v-408bd9a2="" class="el-col el-col-24">
                  <div
                    data-v-0acf6d94=""
                    data-v-408bd9a2=""
                    class="catalog-tabs"
                  >
                    <el-tabs v-model="activeName">
    <el-tab-pane label="目录结构" name="first">
      <div data-v-0acf6d94="" class="tab-panel">
                            <div
                              data-v-33490d76=""
                              data-v-0acf6d94=""
                              class="struct"
                               style="height: 500px; overflow:auto"
                            >
                              <div
                                data-v-33490d76=""
                                class="left"
                                 style="overflow:visible"
                              >

                                <div data-v-33490d76="" v-for="(item, index) of records" :key="index">
                                  <div data-v-33490d76="" class="item">
                                    <!---->
                                    <div
                                      data-v-2b0a0a7c=""
                                      data-v-33490d76=""
                                      class="ctext"
                                    >
                                      <!---->
                                      <div
                                        data-v-2b0a0a7c=""
                                        class="ctext-content mult"
                                        style="-webkit-line-clamp: 1"
                                      >
                                        {{item.paramLst.结构类型}}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    data-v-33490d76=""
                                    class="expandleft"
                                    style="height: 0px"
                                  ></div>
                                </div>

                              </div>
                              <div data-v-33490d76="" class="right"  style="overflow:visible" >
                                <div data-v-33490d76="" v-for="(item, index) of records" :key="index">
                                  <div
                                    data-v-7c3cd46b=""
                                    data-v-33490d76=""
                                    class="clink item"
                                     @click="goToSchemaPage(item,'schema')"
                                  >
                                    <div
                                      data-v-33490d76=""
                                      data-v-7c3cd46b=""
                                      class="title"
                                    >
                                      <span
                                        data-v-33490d76=""
                                        data-v-7c3cd46b=""
                                        class="secondary ellipsis"
                                      >
                                        {{item.paramLst.结构类型}} </span
                                      ><span
                                        data-v-33490d76=""
                                        data-v-7c3cd46b=""
                                        class="ellipsis title-right"
                                        >{{item.title}} </span
                                      >
                                    </div>
                                    <div
                                      data-v-33490d76=""
                                      data-v-7c3cd46b=""
                                      class="line"
                                    ></div>
                                    <div
                                      data-v-33490d76=""
                                      data-v-7c3cd46b=""
                                      class="num"
                                    >{{item.page}}</div>
                                    <div data-v-33490d76="" data-v-7c3cd46b="" class="link"  @click="goToPage(item.page)"> [原版阅读] </div>
                                  </div>
                                </div>
                                </div>

                            </div>
                          </div>
    </el-tab-pane>
    <el-tab-pane label="图表" name="second" v-if="picrecords.length>0">
      <div data-v-0acf6d94="" class="tab-panel">
                            <div
                              data-v-33490d76=""
                              data-v-0acf6d94=""
                              class="struct"
                               style="height: 500px; overflow:auto"
                            >
                              <div
                                data-v-33490d76=""
                                class="left"
                                 style="overflow:visible"
                              >

                                <div data-v-33490d76="" v-for="(item, index) of picrecords" :key="index">
                                  <div data-v-33490d76="" class="item">
                                    <!---->
                                    <div
                                      data-v-2b0a0a7c=""
                                      data-v-33490d76=""
                                      class="ctext"
                                    >
                                      <!---->
                                      <div
                                        data-v-2b0a0a7c=""
                                        class="ctext-content mult"
                                        style="-webkit-line-clamp: 1"
                                      >
                                        {{item.paramLst.结构类型}}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    data-v-33490d76=""
                                    class="expandleft"
                                    style="height: 0px"
                                  ></div>
                                </div>

                              </div>
                              <div data-v-33490d76="" class="right"  style="overflow:visible" >
                                <div data-v-33490d76="" v-for="(item, index) of picrecords" :key="index">
                                  <div
                                    data-v-7c3cd46b=""
                                    data-v-33490d76=""
                                    class="clink item"
                                     @click="goToSchemaPage(item,'pic')"
                                  >
                                    <div
                                      data-v-33490d76=""
                                      data-v-7c3cd46b=""
                                      class="title"
                                    >
                                      <span
                                        data-v-33490d76=""
                                        data-v-7c3cd46b=""
                                        class="secondary ellipsis"
                                      >
                                        {{item.paramLst.结构类型}} </span
                                      ><span
                                        data-v-33490d76=""
                                        data-v-7c3cd46b=""
                                        class="ellipsis title-right"
                                        >{{item.title}} </span
                                      >
                                    </div>
                                    <div
                                      data-v-33490d76=""
                                      data-v-7c3cd46b=""
                                      class="line"
                                    ></div>
                                  </div>
                                </div>
                                </div>

                            </div>
                          </div>
    </el-tab-pane>
    <el-tab-pane label="人物" name="third" v-if="personrecords.length>0">
      <div data-v-0acf6d94="" class="tab-panel">
                            <div
                              data-v-33490d76=""
                              data-v-0acf6d94=""
                              class="struct"
                               style="height: 500px; overflow:auto"
                            >
                              <div
                                data-v-33490d76=""
                                class="left"
                                 style="overflow:visible"
                              >

                                <div data-v-33490d76="" v-for="(item, index) of personrecords" :key="index">
                                  <div data-v-33490d76="" class="item">
                                    <!---->
                                    <div
                                      data-v-2b0a0a7c=""
                                      data-v-33490d76=""
                                      class="ctext"
                                    >
                                      <!---->
                                      <div
                                        data-v-2b0a0a7c=""
                                        class="ctext-content mult"
                                        style="-webkit-line-clamp: 1"
                                      >
                                        人物
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    data-v-33490d76=""
                                    class="expandleft"
                                    style="height: 0px"
                                  ></div>
                                </div>

                              </div>
                              <div data-v-33490d76="" class="right"  style="overflow:visible" >
                                <div data-v-33490d76="" v-for="(item, index) of personrecords" :key="index">
                                  <div
                                    data-v-7c3cd46b=""
                                    data-v-33490d76=""
                                    class="clink item"
                                     @click="goToSchemaPage(item,'person')"
                                  >
                                    <div
                                      data-v-33490d76=""
                                      data-v-7c3cd46b=""
                                      class="title"
                                    >
                                      <span
                                        data-v-33490d76=""
                                        data-v-7c3cd46b=""
                                        class="secondary ellipsis"
                                      >
                                        {{item.title}} </span
                                      ><span
                                        data-v-33490d76=""
                                        data-v-7c3cd46b=""
                                        class="ellipsis title-right"
                                        >{{item.description}} </span
                                      >
                                    </div>
                                    <div
                                      data-v-33490d76=""
                                      data-v-7c3cd46b=""
                                      class="line"
                                    ></div>
                                  </div>
                                </div>
                                </div>

                            </div>
                          </div>
    </el-tab-pane>
    <el-tab-pane label="事件" name="fourth" v-if="eventrecords.length>0">
      <div data-v-0acf6d94="" class="tab-panel">
                            <div
                              data-v-33490d76=""
                              data-v-0acf6d94=""
                              class="struct"
                               style="height: 500px; overflow:auto"
                            >
                              <div
                                data-v-33490d76=""
                                class="left"
                                 style="overflow:visible"
                              >

                                <div data-v-33490d76="" v-for="(item, index) of eventrecords" :key="index">
                                  <div data-v-33490d76="" class="item">
                                    <!---->
                                    <div
                                      data-v-2b0a0a7c=""
                                      data-v-33490d76=""
                                      class="ctext"
                                    >
                                      <!---->
                                      <div
                                        data-v-2b0a0a7c=""
                                        class="ctext-content mult"
                                        style="-webkit-line-clamp: 1"
                                      >
                                        事件
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    data-v-33490d76=""
                                    class="expandleft"
                                    style="height: 0px"
                                  ></div>
                                </div>

                              </div>
                              <div data-v-33490d76="" class="right"  style="overflow:visible" >
                                <div data-v-33490d76="" v-for="(item, index) of eventrecords" :key="index">
                                  <div
                                    data-v-7c3cd46b=""
                                    data-v-33490d76=""
                                    class="clink item"
                                     @click="goToSchemaPage(item,'event')"
                                  >
                                    <div
                                      data-v-33490d76=""
                                      data-v-7c3cd46b=""
                                      class="title"
                                    >
                                      <span
                                        data-v-33490d76=""
                                        data-v-7c3cd46b=""
                                        class="secondary ellipsis"
                                      >
                                        {{item.paramLst.结构类型}} </span
                                      ><span
                                        data-v-33490d76=""
                                        data-v-7c3cd46b=""
                                        class="ellipsis title-right"
                                        >{{item.title}} </span
                                      >
                                    </div>
                                    <div
                                      data-v-33490d76=""
                                      data-v-7c3cd46b=""
                                      class="line"
                                    ></div>
                                  </div>
                                </div>
                                </div>

                            </div>
                          </div>
    </el-tab-pane>
     <el-tab-pane label="组织" name="fifth" v-if="orgrecords.length>0">
      <div data-v-0acf6d94="" class="tab-panel">
                            <div
                              data-v-33490d76=""
                              data-v-0acf6d94=""
                              class="struct"
                               style="height: 500px; overflow:auto"
                            >
                              <div
                                data-v-33490d76=""
                                class="left"
                                 style="overflow:visible"
                              >

                                <div data-v-33490d76="" v-for="(item, index) of orgrecords" :key="index">
                                  <div data-v-33490d76="" class="item">
                                    <!---->
                                    <div
                                      data-v-2b0a0a7c=""
                                      data-v-33490d76=""
                                      class="ctext"
                                    >
                                      <!---->
                                      <div
                                        data-v-2b0a0a7c=""
                                        class="ctext-content mult"
                                        style="-webkit-line-clamp: 1"
                                      >
                                        组织
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    data-v-33490d76=""
                                    class="expandleft"
                                    style="height: 0px"
                                  ></div>
                                </div>

                              </div>
                              <div data-v-33490d76="" class="right"  style="overflow:visible" >
                                <div data-v-33490d76="" v-for="(item, index) of orgrecords" :key="index">
                                  <div
                                    data-v-7c3cd46b=""
                                    data-v-33490d76=""
                                    class="clink item"
                                     @click="goToSchemaPage(item,'org')"
                                  >
                                    <div
                                      data-v-33490d76=""
                                      data-v-7c3cd46b=""
                                      class="title"
                                    >
                                      <span
                                        data-v-33490d76=""
                                        data-v-7c3cd46b=""
                                        class="secondary ellipsis"
                                      >
                                        {{item.paramLst.结构类型}} </span
                                      ><span
                                        data-v-33490d76=""
                                        data-v-7c3cd46b=""
                                        class="ellipsis title-right"
                                        >{{item.title}} </span
                                      >
                                    </div>
                                    <div
                                      data-v-33490d76=""
                                      data-v-7c3cd46b=""
                                      class="line"
                                    ></div>
                                  </div>
                                </div>
                                </div>

                            </div>
                          </div>
    </el-tab-pane>
     <el-tab-pane label="地理" name="sixth" v-if="georecords.length>0">
      <div data-v-0acf6d94="" class="tab-panel">
                            <div
                              data-v-33490d76=""
                              data-v-0acf6d94=""
                              class="struct"
                               style="height: 500px; overflow:auto"
                            >
                              <div
                                data-v-33490d76=""
                                class="left"
                                 style="overflow:visible"
                              >

                                <div data-v-33490d76="" v-for="(item, index) of georecords" :key="index">
                                  <div data-v-33490d76="" class="item">
                                    <!---->
                                    <div
                                      data-v-2b0a0a7c=""
                                      data-v-33490d76=""
                                      class="ctext"
                                    >
                                      <!---->
                                      <div
                                        data-v-2b0a0a7c=""
                                        class="ctext-content mult"
                                        style="-webkit-line-clamp: 1"
                                      >
                                        地理
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    data-v-33490d76=""
                                    class="expandleft"
                                    style="height: 0px"
                                  ></div>
                                </div>

                              </div>
                              <div data-v-33490d76="" class="right"  style="overflow:visible" >
                                <div data-v-33490d76="" v-for="(item, index) of georecords" :key="index">
                                  <div
                                    data-v-7c3cd46b=""
                                    data-v-33490d76=""
                                    class="clink item"
                                     @click="goToSchemaPage(item,'geo')"
                                  >
                                    <div
                                      data-v-33490d76=""
                                      data-v-7c3cd46b=""
                                      class="title"
                                    >
                                      <span
                                        data-v-33490d76=""
                                        data-v-7c3cd46b=""
                                        class="secondary ellipsis"
                                      >
                                        {{item.paramLst.行政层级}} </span
                                      ><span
                                        data-v-33490d76=""
                                        data-v-7c3cd46b=""
                                        class="ellipsis title-right"
                                        >{{item.title}} </span
                                      >
                                    </div>
                                    <div
                                      data-v-33490d76=""
                                      data-v-7c3cd46b=""
                                      class="line"
                                    ></div>
                                  </div>
                                </div>
                                </div>

                            </div>
                          </div>
    </el-tab-pane>
  </el-tabs>
                  </div>
                </div>
              </div>
              </div>
            <div class="book-chart-div">
			<bookStatistics :sourceId='sourceId'></bookStatistics>
		</div>
    <div class="type-word-cloud-view">
			<wordCloud :sourceId='sourceId'></wordCloud>
		</div>
            <div data-v-a36ddf66="" class="description-header">
                <div data-v-a36ddf66="" class="title"></div>
                <div data-v-a36ddf66="" class="border"></div>
              </div>
                <div data-v-2620c8cd="" data-v-a36ddf66="" class="mult">
                  <div
                    data-v-53ea770e=""
                    data-v-2620c8cd=""
                    class="description-item"
                    data-v-a36ddf66=""
                    v-for="(value,key) in bookDetail.paramLst" :key="key"
                    v-if="value!==''&& value!==null"
                  >
                    <div data-v-53ea770e="" class="description-item-label">
                      <div data-v-2b0a0a7c="" data-v-53ea770e="" class="ctext">
                        <div
                          data-v-2b0a0a7c=""
                          class="ctext-dot"
                          style="width: 5px; height: 5px"
                        ></div>
                        <div data-v-2b0a0a7c="" class="ctext-content">
                          {{key}}
                        </div>
                      </div>
                    </div>
                    <div data-v-53ea770e="" class="description-item-value">
                      <div data-v-2b0a0a7c="" data-v-53ea770e="" class="ctext">
                        <!---->
                        <div data-v-2b0a0a7c="" class="ctext-content">
                         {{value}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!---->
            <!---->

          </div>
        </div>
      </div>
    </div>

            </div>
          </div>
          <!---->
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import bookApi from '@/api/book';
import bookStatistics from './bookStatistics'
import wordCloud from './wordCloud'

export default {
  components: {
		bookStatistics,
    wordCloud
	},
  data () {
    return {
      records: [],
      picrecords: [],
      personrecords: [],
      eventrecords: [],
      orgrecords: [],
      georecords: [],
      bookDetail: {},
      currentBookType: {},
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      searchValue: '',
      pagePic: '',
      activeName: 'first',
      sourceId: ''
    };
  },
  mounted () {},
  methods: {
    getDataDetail (sourceId, bookType, schemaType) {
      this.records = [];
      this.sourceId = sourceId;
      let that = this;

    /*   bookApi
        .getBook({
          path: 'getBookBase',
          pageindex: this.pageindex,
          pageSize: this.pageSize,
          sourceID: bookId,
          libraryCode: this.global.getLibraryInfos().code
        }) */

      bookApi.getBook({
          path: 'getBookDataWithPrs',
          pageindex: this.pageindex,
          pageSize: this.pageSize,
          sourceID: sourceId,
          bookType: bookType,
          schemaType: schemaType,
          libraryCode: this.global.getLibraryInfos().code
        })

        .then((response) => {
          console.log(response);
          if (response.code === 200) {
            that.bookDetail = response.data.rows[0];
            that.transPdfToImage(that.bookDetail.pagePic);
          }
        });
    },
    getSchemaDetail (sourceId, bookType) {
      this.records = [];
      let that = this;

      bookApi
        .getBook({
          path: 'getBookDataWithPrs',
          pageindex: that.pageindex,
          pageSize: 9999,
          sourceID: sourceId,
          bookType: bookType,
          schemaType: 'schema',
          libraryCode: that.global.getLibraryInfos().code
        })
        .then((response) => {
          console.log(response);
          if (response.code === 200) {
            that.records = response.data.rows;
          }
        });
    },

     getPicDetail (sourceId, bookType) {
      this.picrecords = [];
      let that = this;

      bookApi
        .getBook({
          path: 'getBookDataWithPrs',
          pageindex: that.pageindex,
          pageSize: 9999,
          sourceID: sourceId,
          bookType: bookType,
          schemaType: 'pic',
          libraryCode: that.global.getLibraryInfos().code
        })
        .then((response) => {
          console.log(response);
          if (response.code === 200) {
            that.picrecords = response.data.rows;
          }
        });
    },

     getPersonDetail (sourceId, bookType) {
      this.personrecords = [];
      let that = this;

      bookApi
        .getBook({
          path: 'getBookDataWithPrs',
          pageindex: that.pageindex,
          pageSize: 9999,
          sourceID: sourceId,
          bookType: bookType,
          schemaType: 'person',
          libraryCode: that.global.getLibraryInfos().code
        })
        .then((response) => {
          console.log(response);
          if (response.code === 200) {
            that.personrecords = response.data.rows;
          }
        });
    },

     getEventDetail (sourceId, bookType) {
      this.eventrecords = [];
      let that = this;

      bookApi
        .getBook({
          path: 'getBookDataWithPrs',
          pageindex: that.pageindex,
          pageSize: 9999,
          sourceID: sourceId,
          bookType: bookType,
          schemaType: 'event',
          libraryCode: that.global.getLibraryInfos().code
        })
        .then((response) => {
          console.log(response);
          if (response.code === 200) {
            that.eventrecords = response.data.rows;
          }
        });
    },
    getOrgDetail (sourceId, bookType) {
      this.orgrecords = [];
      let that = this;

      bookApi
        .getBook({
          path: 'getBookDataWithPrs',
          pageindex: that.pageindex,
          pageSize: 9999,
          sourceID: sourceId,
          bookType: bookType,
          schemaType: 'org',
          libraryCode: that.global.getLibraryInfos().code
        })
        .then((response) => {
          console.log(response);
          if (response.code === 200) {
            that.orgrecords = response.data.rows;
          }
        });
    },
    getGeoDetail (sourceId, bookType) {
      this.georecords = [];
      let that = this;

      bookApi
        .getBook({
          path: 'getBookDataWithPrs',
          pageindex: that.pageindex,
          pageSize: 9999,
          sourceID: sourceId,
          bookType: bookType,
          schemaType: 'geo',
          libraryCode: that.global.getLibraryInfos().code
        })
        .then((response) => {
          console.log(response);
          if (response.code === 200) {
            that.georecords = response.data.rows;
          }
        });
    },

    transPdfToImage (pdfUrl) {
       let that = this;
       pdfUrl = pdfUrl.replace('http://localhost:8090/book', 'http://47.95.223.196:8090/book');
			$('#imgDiv').empty();
			// function fileToDataURL (file) {
			// 	let reader = new FileReader()
			// 	reader.readAsDataURL(file)
			// 	// reader 读取文件成功的回调
			// 	reader.onload = function (e) {
			// 	return reader.result
			// 	}
			// }
			// function blobToFile (value, filename = 'file') {
			// return new window.File([value], filename, { type: value.type });
			// }

			function output () {
				var height = 0; var context; var mainCanvas; var b = 2; // b：整图缩放倍数
				var count = 1;
				$('canvas').each(function (index, ele) {
					var canvas = document.getElementById('pdfCanvas');
					if (canvas) {
						if (index === 0) {
							mainCanvas = document.createElement('canvas');
							context = mainCanvas.getContext('2d');
							mainCanvas.width = canvas.width / b;
							mainCanvas.height = canvas.height / b * count;
							context.drawImage(canvas, 0, 0, canvas.width / b, canvas.height / b);
						} else {
							context.drawImage(canvas, 0, height, canvas.width / b, canvas.height / b);
						}
						height += canvas.height / b;
					}
				})
				if (mainCanvas) {
					// let img = dataURLtoBlob(mainCanvas.toDataURL('image/png', 1.0));
					that.pagePic = mainCanvas.toDataURL('image/png', 0.1).replace(/[\r\n]/g, '');
					// eslint-disable-next-line no-new
					// new Compressor(dataURLtoBlob(img), {
					// 	quality: 0,
					// 	success (result) {
					// 		console.log(result) // 处理后的文件流BLOB
					// 		let reader = new FileReader()
					// 		reader.readAsDataURL(result)
					// 		// reader 读取文件成功的回调
					// 		reader.onload = function (e) {
					// 			console.log('压缩后', reader.result);
					// 			that.pages.push(reader.result);
					// 			that.addPage(that.currentPage + 1);
					// 			$('#imgDiv').empty();
					// 			return reader.result
					// 		}
					// 	},
					// 	error (err) {
					// 	// 错误处理
					// 		console.log(err.message)
					// 	}
					// })
					$('#imgDiv').empty();
					// that.bookShow = true;
				}
			}
			function openPage (pdfFile, pageNumber, context) {
				var scale = 2;
				pdfFile.getPage(pageNumber).then(page => {
					let viewport = page.getViewport(scale); // reference canvas via context
					var canvas = context.canvas;
					canvas.width = viewport.width;
					canvas.height = viewport.height;
					// 记录当前canvas的width，height
					window.wi = canvas.width;
					window.he = canvas.height;
					canvas.style.width = '100%';
					canvas.style.height = '100%';
					var renderContext = {
						canvasContext: context,
						viewport: viewport
					};
					page.render(renderContext).then(e => {
						output();
					});
				});
			};

			PDFJS.getDocument(pdfUrl).then(pdf => {
				$('#imgDiv').css('border', '0'); // 清除文本、边框
				if (pdf) {
					window.pageNum = pdf.numPages;
					// $('#pagesText').text(pageNum);
					var canvas = document.createElement('canvas');
					canvas.id = 'pdfCanvas';
					$('#imgDiv').append(canvas);
					var context = canvas.getContext('2d');
					openPage(pdf, 1, context);
				}
			});
		},

    goToPage (startFileName) {
      if (startFileName) {
      if (startFileName.lastIndexOf('.') > 0) {
        startFileName = startFileName.substring(0, startFileName.lastIndexOf('.')).toUpperCase()
      } else {
        startFileName = startFileName.toUpperCase()
      }
      }

      let routeData = this.$router.resolve({
        path: '/bookView',
        query: {
          bookId: this.bookDetail.sourceID,
          bookType: 'book',
          startPage: startFileName
        }
      });

      // 必要操作，否则不会打开新页面
      window.open(routeData.href, '_blank');
    },
    goToSchemaPage (item, type) {
      let routeData = this.$router.resolve({
          path: '/schemaDetail',
          query: {
            identifier: item.identifier,
            bookType: 'book',
            schemaType: type
          }
        });

        // 必要操作，否则不会打开新页面
        window.open(routeData.href, '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.content-view {
  width: 900 * @uw;
  // height: 50 *@uw;
  // background: bisque;

  .header {
    width: 100%;
    height: 25 * @uh;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .search-box {
      width: 250 * @uw;
      display: flex;
      align-items: center;
    }
  }

  .searchDiv {
    width: 200 * @uw;
    // margin: 0px 0 20px 0px;
  }

  .bookInfo {
    margin-bottom: 30 * @uh;
    padding-bottom: 10 * @uh;
    border-bottom: dashed 1px rgba(0, 0, 0, 0.1);
    .title {
      color: #6d6d6d;
      font-size: 18 * @uw;
      font-weight: bold;
      margin-bottom: 10 * @uh;
      cursor: pointer;
    }

    .content {
      font-size: 14 * @uw;
      margin-bottom: 10 * @uh;
    }

    .contributor {
      font-size: 13 * @uw;
      color: #8e8e8e;
    }
  }
  .page {
    width: 100%;
    margin: 0 auto;
    max-width: 1200px;
    min-width: 1200px;
    .page-warp {
      padding: 32px 0;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .page-col {
        width: 100%;
      }
    }
    .catalog-card[data-v-408bd9a2] {
      border-radius: 6px;
      box-shadow: 0 0 10px hsla(0, 0%, 85.9%, 0.35);
    }
    .catalog-card-header[data-v-408bd9a2] {
      padding: 22px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .catalog-card-content[data-v-408bd9a2] {
      padding: 0 32px 32px 32px;
    }
  }
    .bookinfo-img[data-v-6edc5341] {
      max-height: 270px;
      height: 100%;
      width: 195px;
      border-radius: 6px;
      overflow: hidden;
      display: flex;
      margin-right: 50px;
    }
    .bookinfo[data-v-6edc5341] {
      display: flex;
      justify-content: flex-start;
    }
    .bookinfo-info[data-v-6edc5341] {
      font-size: 14px;
      line-height: 1;
      margin-top: 12px;
      text-align: left;
      .title[data-v-6edc5341] {
        font-size: 18px;
        font-weight: 700;
        .infos[data-v-6edc5341] {
          margin-top: 30px;
          color: #6d6d6d;
        }
      }
    }
    .bookinfo-info .infos .row[data-v-6edc5341] {
    margin-top: 13px;
}
.bookinfo-info .infos .row .lable[data-v-6edc5341] {
    width: 56px;
    display: inline-block;
    -moz-text-align-last: justify;
    text-align-last: justify;
}
.bookinfo .el-button--danger[data-v-6edc5341] {
    margin-top: 20px;
    color: #fff;
    font-size: 16px;
    background-color: #ec0f1a;
    border-color: #ec0f1a;
    padding: 12px 30px;
}
.catalog-tabs[data-v-0acf6d94] {
    padding-top: 50px;
    font-size: 16px;
}
.el-tabs__nav-wrap {
    overflow: hidden;
    margin-bottom: -1px;
    position: relative;
}
.el-tabs__nav {
    white-space: nowrap;
    position: relative;
    transition: transform .3s;
    float: left;
    z-index: 2;
}
.web-tabs #tab-all {
    width: 180px;
}
.web-tabs #tab-all .tab-pane-all {
    width: 140px;
    display: block;
    background-color: #e2c293;
    color: #333;
}
.web-tabs #tab-all .tab-pane-all:after {
    content: "";
    position: absolute;
    top: 0;
    right: 8px;
    bottom: 0;
    background-color: #8d5e1a;
    width: 50px;
    height: 100%;
    -webkit-clip-path: polygon(35% 0,0 100%,100% 100%);
    clip-path: polygon(35% 0,0 100%,100% 100%);
}
.el-tabs__content {
    overflow: hidden;
    position: relative;
}
.catalog-tabs .tab-panel[data-v-0acf6d94] {
    font-size: 14px;
}
.struct[data-v-33490d76] {
    position: relative;
    display: flex;
    font-size: 14px;
    padding-bottom: 30px;
}
.struct .left[data-v-33490d76] {
    width: 140px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
    padding: 16px 0;
}
.struct .left .item[data-v-33490d76] {
    cursor: pointer;
    width: 95px;
    height: 30px;
    line-height: 1;
    margin-top: 8px;
    padding: 0 8px;
    background: #ffebcf;
    color: #8d5e1a;
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-weight: 700;
}
.ctext[data-v-2b0a0a7c] {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.ctext-content.mult[data-v-2b0a0a7c] {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}
.struct .left .expandleft[data-v-33490d76] {
    transition: all .3s ease-in-out;
}
.struct .right[data-v-33490d76] {
    flex: 1;
    border-left: 1px solid rgba(141,94,26,.6);
    padding: 22px;
    padding-right: 0;
    min-height: 200px;
    font-size: 14px;
    color: #646464;
    text-align: left;
}
.struct .right .item[data-v-33490d76] {
    height: 38px;
    display: flex;
    justify-content: space-between;
    align-items: center;
        width: 1000 * @uw;
}
.struct .right .item .title[data-v-33490d76] {
    padding-right: 16px;
    display: flex;
    align-items: center;
}
.struct .right .item .title .secondary[data-v-33490d76] {
    display: inline-block;
    width: 80px;
    font-weight: 700;
}
.ellipsis {
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.struct .right .item .line[data-v-33490d76] {
    flex: 1;
    position: relative;
    height: 1;
    border-bottom: 1px dashed rgba(0,0,0,.1);
}
.struct .right .item .num[data-v-33490d76] {
    padding-left: 16px;
}
.struct .right .item .link[data-v-33490d76] {
    margin-left: 10px;
    padding: 2px 10px;
    display: block!important;
    font-size: 14px;
    font-weight: 400;
    color: #a40100;
    cursor: pointer;
}
.card-wrap-header[data-v-389d87ef] {
    padding: 22px 18px 22px 22px;
    border-bottom: 1px solid rgba(51,51,51,.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-style: normal;
}
.card-wrap-header .title[data-v-389d87ef] {
    font-weight: 700;
    font-size: 16px;
    color: #8d5e1a;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
}
.flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}
.card-wrap-header .title .unicon[data-v-389d87ef] {
    height: 14px;
    margin-right: 12px;
    width: 5px;
    display: block;
    border-radius: 3px;
    margin-top: 3px;
    background-color: #a40100;
}
.description-header[data-v-a36ddf66] {
    font-size: 16px;
    font-weight: 700;
    color: #595959;
    display: inline-flex;
    flex-direction: column;
}
.book-catelog .mult[data-v-1c192527] {
    display: flex;
    flex-wrap: wrap;
    align-items: normal;
    justify-content: space-between;
    padding: 0 25px 25px 25px;
}
.book-catelog .mult .description-item[data-v-1c192527] {
    width: 45.5%;
}
.description-item[data-v-53ea770e] {
    padding: 8px 0;
    border-bottom: 1px dashed rgba(0,0,0,.1);
    padding-left: 8px;
}
.description-item-label[data-v-53ea770e] {
    position: relative;
    color: #939393;
    font-weight: 400;
    font-size: 12px;
}
.ctext-dot[data-v-2b0a0a7c] {
    margin-right: 8px;
    border-radius: 99px;
    background-color: #8d5e1a;
    opacity: .6;
}
.ctext-content[data-v-2b0a0a7c] {
    flex: 1;
    white-space: pre-line;
    word-break: break-all;
    line-height: 24px;
}
.description-item-value[data-v-53ea770e] {
    margin-left: 11px;
    margin-top: 8px;
    color: #595959;
    font-weight: 700;
    font-size: 14px;
}
.ctext-content[data-v-2b0a0a7c] {
    flex: 1;
    white-space: pre-line;
    word-break: break-all;
    line-height: 24px;
}
.mult[data-v-1c192527] {
    display: flex;
    flex-wrap: wrap;
    align-items: normal;
    justify-content: space-between;
    padding: 0 25px 25px 25px;
}
.description-item[data-v-1c192527] {
    width: 45.5%;
}
.description-item[data-v-53ea770e] {
    padding: 8px 0;
    border-bottom: 1px dashed rgba(0,0,0,.1);
    padding-left: 8px;
}
.description-item-label[data-v-53ea770e] {
    position: relative;
    color: #939393;
    font-weight: 400;
    font-size: 12px;
}
.book-chart-div {
		width: 1100 * @uw;
		height: 440 * @uh;
		margin-top: 30 * @uh;
		margin-left: 10 * @uw;
	}
  .type-word-cloud-view {
		width: 1100 * @uw;
		height: auto;
		margin-top: 60 * @uh;
		margin-left: 10 * @uw;
		padding-bottom: 30 * @uh;
    display: flex;
		justify-content: space-between;
	}
  .wordCloudView {
    width: 1100 * @uw;
    height: 450 * @uw;
    position: relative;
    box-shadow: none;
  }
  }

:deep(.el-card__header) {
  color: #8d5e1a;
  font-weight: bold;
}
</style>

<style src="./app.841a88aa.css"  scoped>
</style>
